import { Type } from 'class-transformer';

import { Question } from './question.model';

export class PageModel {
  @Type(() => Question)
  questions: Question[];

  constructor(public id: string = null) {
    this.questions = [];
  }

  get visibleQuestions(): Question[] {
    return this.questions.filter((question) => question.visible && !question.neverShow);
  }
}
